import {Icon} from 'antd'

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_921073_apr514a6eab.js',
});
IconFont.pre = 'product'
export default IconFont